import { render, staticRenderFns } from "./CampaignReport.vue?vue&type=template&id=2c72d0c9&scoped=true"
import script from "./CampaignReport.vue?vue&type=script&lang=js"
export * from "./CampaignReport.vue?vue&type=script&lang=js"
import style0 from "./CampaignReport.vue?vue&type=style&index=0&id=2c72d0c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72d0c9",
  null
  
)

export default component.exports